import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'Portale',
      en: 'Portals'
    },
    description: {
      de: 'Kundenportale und Self-Service-Lösungen für bessere Kundenerfahrung.',
      en: 'Customer portals and self-service solutions for better customer experience.'
    }
  }
}); 